import * as f from '../../../components/BPMTable/BPMInputs'
import {
    TableFieldDescription, 
    DataMapper, 
    StatusComponentCreator,
    BooleanExcelDisplayCreator
} from '../../../components/BPMTable/TableMapperCreator'
import TableCreatorCreator from '../../../components/BPMTable/TableCreatorFactory/TableCreatorCreator'
import { DirectTableQueryBuilder } from "../../../components/BPMTable/TableQueryBuilder/DirectTableQueryBuilder"
import tableCreatorCreatorFactoryCreator from '../../../components/BPMTable/TableCreatorFactory/TableCreatorCreatorFactoryCreator'


const queries = {tableQueryBuilder: new DirectTableQueryBuilder('allSites')}

class InventorySitesMinimalTableCreator extends TableCreatorCreator {
    constructor(filters) {
        super(filters)
    }

    static getId = () => {
        return "InventorySitesMinimalTableCreator"
    }

    getTableCreator = (tableName) => {
        const tableCreator =  this.createTableCreator(this.constructor.getId(), tableName, queries)
        tableCreator.setAdditionalFilters(this.filters)
        tableCreator.addDescriptions([
            new TableFieldDescription(
                'enterpriseId',
                new DataMapper('enterpriseId'),
                new f.FilterDescription(new f.TextFilter('enterpriseId')),
                {label: 'Enterprise Id'}
            ),
            new TableFieldDescription(
                'name',
                new DataMapper('name'),
                new f.FilterDescription(new f.TextFilter('name')),
                {label: 'Name'}
            ),
            new TableFieldDescription(
                'address',
                new DataMapper('address'),
                new f.FilterDescription(new f.TextFilter('address')),
                {label: 'Address'}
            ),
            new TableFieldDescription(
                'postalCode',
                new DataMapper('postalCode'),
                new f.FilterDescription(new f.TextFilter('postalCode')),
                {label: 'Postal Code'}
            ),
            new TableFieldDescription(
                'state',
                new DataMapper('state'),
                new f.FilterDescription(new f.TextFilter('state')),
                {label: 'State'}
            ),
            new TableFieldDescription(
                'country',
                new DataMapper('country.name'),
                new f.FilterDescription(new f.TextFilter('country')),
                {label: 'Country'}
            ),
            new TableFieldDescription(
                'domain',
                new DataMapper('domain.name'),
                new f.FilterDescription(new f.TextFilter('domain')),
                {label: 'Domain'}
            ),
            new TableFieldDescription(
                'isActive',
                new DataMapper('isActive'),
                new f.FilterDescription(new f.BooleanFilter('isActive')),
                {label: 'Status', componentCreator: new StatusComponentCreator(), excelDisplay: new BooleanExcelDisplayCreator()}
            ),
            new TableFieldDescription(
                'type',
                new DataMapper('type'),
                new f.FilterDescription(new f.TextFilter('type')),
                {label: 'Type'}
            ),
        ])

        return tableCreator;
    }
}

tableCreatorCreatorFactoryCreator.addTableCreatorCreator(InventorySitesMinimalTableCreator)

export default InventorySitesMinimalTableCreator;
